var map = {
	"./black/duofanghuiyi2.png": "HIAz",
	"./blue/duofanghuiyi2.png": "S6rY",
	"./white/duofanghuiyi2.png": "durq"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Z92x";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/duofanghuiyi2\.png$
// module id = Z92x
// module chunks = 24